<style src="./RequestConfirm.scss" lang="scss"></style>
<template>
  <modal
    transition="nice-modal-fade"
    :name="name"
    width="900px"
    height="auto"
    :scrollable="true"
    @closed="whenCloseModal">
    <aside class="request-confirm">
      <section class="illustration">
        <svg 
          class="send"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 788.38181 719">
          <defs>
            <linearGradient
              x1="365" y1="605" x2="365" y2="286"
              gradientUnits="userSpaceOnUse">
              <stop offset="0" stop-opacity="0.12"/>
              <stop offset="0.55135" stop-opacity="0.09"/>
              <stop offset="1" stop-opacity="0.02"/>
            </linearGradient>
            <linearGradient x1="1117.61899" y1="-43.05793" x2="1117.61899" y2="-102.40539" gradientTransform="matrix(-0.64881, 0.76095, 0.76095, 0.64881, 817.40491, -656.85567)" gradientUnits="userSpaceOnUse">
              <stop offset="0" stop-color="gray" stop-opacity="0.25"/>
              <stop offset="0.53514" stop-color="gray" stop-opacity="0.12"/>
              <stop offset="1" stop-color="gray" stop-opacity="0.1"/>
            </linearGradient>
          </defs>
          <title>Mail sent</title>
          <polygon points="125 410 0 268 374 0 748 268 621 410 125 410" fill="#6c63ff"/>
          <polygon points="125 410 0 268 374 0 748 268 621 410 125 410" fill="#514abf"/>
          <rect y="286" width="730" height="319" fill="#6c63ff"/>
          <rect y="286" width="730" height="319" fill="url(#aeee3e51-5d06-43ae-b234-e7a12d326f50)"/>
          <polygon points="748 719 0 719 0 268 374 494 748 268 748 719" fill="#6c63ff"/>
          <polygon points="652.582 116.818 573.252 55.99 363.113 330.042 246.402 240.55 185.573 319.879 341.938 439.598 341.938 439.598 382.036 469.649 652.582 116.818" fill="#3ad29f"/>
          <polygon points="3.153 166.882 0.179 168.334 0.521 167.726 0.26 167.81 0.626 167.539 40.653 96.307 61.114 113.753 78.667 130.004 73.627 132.465 79.293 142.459 3.153 166.882" fill="url(#acb63a3b-00bb-44a8-8877-bb0607d49a63)"/>
          <polygon points="59.087 115.617 75.131 130.493 2.411 166.646 41.11 117.046 59.087 115.617" fill="#6c63ff"/>
          <polygon points="59.087 115.617 75.131 130.493 2.411 166.646 41.11 117.046 59.087 115.617" opacity="0.2"/>
          <polygon points="40.373 99.66 2.411 166.646 59.087 115.617 40.373 99.66" fill="#6c63ff"/>
          <polygon points="75.599 142.01 2.489 166.16 63.604 120.539 75.599 142.01" fill="#6c63ff"/>
          <polygon points="686.959 38.73 670.942 66.499 788.382 85.622 712.742 32.949 686.959 38.73" fill="#6c63ff"/>
          <polygon points="686.959 38.73 670.942 66.499 788.382 85.622 712.742 32.949 686.959 38.73" opacity="0.2"/>
          <polygon points="706.247 8.293 788.382 85.622 686.959 38.73 706.247 8.293" fill="#6c63ff"/>
          <polygon points="675.274 82.821 788.062 84.976 682.769 47.576 675.274 82.821" fill="#6c63ff"/>
        </svg>
      </section>

      <form
        @submit.stop.prevent="submitForm"
        class="panel">
        <span class="title">Quando foi enviado?</span>
        <p>Para auxiliar no controle das cotações precisamos saber quando ela foi enviada.</p>
        <p v-show="!alreadySended">Informe nos campos abaixo a data e hora de envio!</p>
        <p v-show="alreadySended">A data e hora informada abaixo corresponde ao primeiro envio. Você pode altera-lo se desejar.</p>

        <div class="form">
          <datebox
            class="col-6"
            label="Data do envio*"
            placeholder="03/01/2078"
            v-model="requestDate" />

          <timebox
            class="col-6"
            label="Hora do envio"
            placeholder=""
            v-model="requestTime" />
        </div>

        <div class="commands">
          <button
            type="button"
            class="btn-ghost"
            @click="closeModal">
            Cancelar
          </button>
          <button
            type="button"
            class="btn-danger"
            @click="undoSubmit">
            Desfazer Envio
          </button>
          <button-submit
            class="col-5"
            label="Salvar Cliente"
            :state="commands.submitState"
            :icon-save="commands.saveIcon"/>
        </div>
      </form>
    </aside>
  </modal>
</template>

<script>
import moment from 'moment'
import { Datebox, Timebox, ButtonSubmit } from '@/components/primitives'
import { IconSave, IconClose } from '@/components/primitives/icons'

export default {
  name: 'RequestConfirm',
  components: {
    Datebox,
    Timebox,
    ButtonSubmit,
    IconSave,
    IconClose
  },
  props: {
    name: {
      default: 'modalResquestConfirm'
    },
    modalRequestForm: {
      default: null
    }
  },
  data () {
    return {
      requestDate: '',
      requestTime: '',
      commands: {
        submitState: 'REPOSE',
        saveIcon: IconSave
      },
      alreadySended: false
    }
  },
  watch: {
    modalRequestForm: {
      handler () {
        this.setDateTime()
      },
      deep: true,
      immediate: true
    }
  },
  mounted () {
    this.setDateTime()
  },
  methods: {
    setDateTime () {
      const requestDateTime = this.modalRequestForm && this.modalRequestForm.requestDate

      let dt = null
      if (requestDateTime) {
        dt = requestDateTime
        this.alreadySended = true
      } else {
        this.alreadySended = false
        dt = new Date()
      }

      const d = moment(dt).format('DD/MM/YYYY')
      const t = moment(dt).format('HH:mm:00')

      this.requestDate = d
      this.requestTime = t
    },
    whenCloseModal () {},
    async submitForm () {
      this.commands.submitState = 'WAIT'

      const requestDate = moment(`${this.requestDate} ${this.requestTime}`, 'DD/MM/YYYY hh:mm:ss').toDate()

      const payload = this.modalRequestForm.computedItems.map(i => ({
        quoteId: i._id,
        supplierId: this.modalRequestForm.supplierId,
        requestDate
      }))
      try {
        await this.$store.dispatch('Quote/SAVE_QUOTATION_REQUEST', { payload })

        const eventId = this.$route.params.id
        await this.$store.dispatch('Quote/LOAD_EVENT_LIST', { eventId })
      } catch (error) {
        this.$toasted.show('Não foi possível salvar')
      } finally {
        this.commands.submitState = 'REPOSE'
        this.$emit('close')
      }
    },
    async undoSubmit () {
      this.commands.submitState = 'WAIT'

      const payload = this.modalRequestForm.computedItems.map(i => ({
        quoteId: i._id,
        supplierId: this.modalRequestForm.supplierId,
        requestDate: null
      }))
      try {
        await this.$store.dispatch('Quote/SAVE_QUOTATION_REQUEST', { payload })

        const eventId = this.$route.params.id
        await this.$store.dispatch('Quote/LOAD_EVENT_LIST', { eventId })
      } catch (error) {
        this.$toasted.show('Não foi possível salvar')
      } finally {
        this.commands.submitState = 'REPOSE'
        this.$emit('close')
      }
    },
    closeModal () {
      this.$emit('close')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/item-quote/components/request-confirm/RequestConfirm.vue